var t=/^\s*$/,a=a=>!a||t.test(a);export{a as default};